var Ractive = require('ractive');
var component = module;

  component.exports = {
    onrender: function (options) {
      var self = this;
      var $ = require('jquery'), jQuery = $
      if(ConfigClient&&ConfigClient.InfoKey){
        self.set('login.InfoKey', ConfigClient.InfoKey);
        self.set('InfoKeyClient', ConfigClient.InfoKey);
      }else{
        if(ConfigClient.ProjectKey){
          self.set('login.InfoKey', "");
          self.set('login.ProjectKey', ConfigClient.ProjectKey);
          self.set('InfoKeyClient', "");
        }else{
          let fLastInfoKey = Client.getLastUserKey();
          if(fLastInfoKey){
            self.set('login.InfoKey', Client.getLastUserKey());
          }
        }
      }

			if((typeof(Global)=="object")&&(Global.Config)){
				if(Global.Config.LinkHelp){
					this.set('LinkHelp', Global.Config.LinkHelp);
				}
				if(Global.Config.LinkManual){
					this.set('LinkManual', Global.Config.LinkManual);
				}
			}   

      if(window.location.pathname.toLowerCase()=="/login"){
        self.set('ribbonShow', false);
      }

      self.on('doRefresh', function (e) {
        if(Global&&Global.Session&&Global.Session.Status){
          self.fire('setTab', 'profil');

          var fRequest = {
                Name: "Sql",
                Action: "Query",
                Query: "ERP-Profile-Web",
                Payload: {
                  username: Global.Session.UserName,
                  useruid: Global.Session.UserUID,
                  infokey: Global.Session.InfoKey
                },
                Behavior: { Rows: "UserRow", loading: "loading", singleRow: true }
              };
          self.cmd.Data(self, fRequest);          
        }else{
          self.fire('setTab', 'enter');
        }
        self.set('CacheData.Users', Client.getUsers());
      });
      self.on('setTab', function (iName, iIndex) {
        //self.set('displayName', iName);
        self.set('d.Tab', iName);
        var $ = require('jquery'), jQuery = $;

        switch (iName) {
          case "enter":
           /* $('#loginInfoKey').keypress(function (e) {
              if (e.which == 13) {
                self.fire('doEnter', self.get('login'));
                return false;
              }
            });*/
            $('#loginUserName').keypress(function (e) {
              if (e.which == 13) {
                self.fire('doEnter', self.get('login'));
                return false;
              }
            });
            $('#loginPassword').keypress(function (e) {
              if (e.which == 13) {
                self.fire('doEnter', self.get('login'));
                return false;
              }
            });
            var fLogin = self.get('login');
            /*if(!(fLogin.InfoKey)){
              $('#loginInfoKey').focus();
              return ;
            }*/
            if(!(fLogin.UserName)){
              $('#loginUserName').focus();
              return ;
            }
            if(!(fLogin.UserPass)){
              $('#loginPassword').focus();
              return ;
            }            
            break;
          case "login":
            $('#loginPassword').focus();
            $('#loginPassword').keypress(function (e) {
              if (e.which == 13) {
                self.fire('doEnter', self.get('User'));
                return false;
              }
            });
            break;
          case "pin":
            $('#accessPIN').focus();
            $('#accessPIN').keypress(function (e) {
              if (e.which == 13) {
                self.fire('doEnter', self.get('User'));
                return false;
              }
            });
            break;
        }
      });
      self.on('doUserSet', function (iLogin) {
        if(iLogin){
          if(iLogin.UserName){
            self.set('login.UserName', iLogin.UserName);
          }
          if(iLogin.InfoKey){
            self.set('login.InfoKey', iLogin.InfoKey);
          }
          $('#loginPassword').focus();
        }
      });
      self.on('doUserClear', function (iLogin) {
        localStorage.setItem('Users', '{}');
        self.set('CacheData.Users', {});
      });      
      self.on('doEnter', function (iLogin) {
        var fLogin = iLogin;
        var isValidValue = function(iValue){
          return ((iValue)&&(0<iValue.length));
					if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(iValue)){
						return true;
					};

					return false;
        }
        self.set('login.MessageError', '');
        /*if(!isValidValue(fLogin.InfoKey)){
          self.set('login.InfoKeyError', true);
          $('#loginInfoKey').focus();
          return ;
        }else{
          self.set('login.InfoKeyError', false);
        }*/
        if(!isValidValue(fLogin.UserName)){
          self.set('login.UserNameError', true);
          $('#loginUserName').focus();
          return ;
        }else{
          self.set('login.UserNameError', false);
        }
        if(!isValidValue(fLogin.UserPass)){
          self.set('login.PasswordError', true);
          $('#loginPassword').focus();
          return ;
        }else{
          self.set('login.PasswordError', false);
        }
        self.set('loading', true);
        self.cmd.Login(self, fLogin, function (oService, oData) {
          if(oData.Status){
            if(ConfigClient&&ConfigClient.ProjectKey){
              self.set('d.Tab', 'profil');
            }else{
              setTimeout(function(){ 
                window.location.href = "/erp";
              }, 800);
            }
          }else{
            self.set('login.MessageError', oData.Error);
          }
          self.set('loading', false);
        });
      });
      self.on('doPIN', function (iLogin) {
        var fUser = (iLogin) ? iLogin : self.get('User');

        fUser.MailFrom = "noreply@nte.rs";
        fUser.MailTo = fUser.UserName;
        fUser.MailSubject = "New pin for login";
        fUser.UserPass = Client.getPin(4);
        fUser.MailBody = "New pin for login: " + fUser.UserPass;
        //fUser.MailService = {};

        var SrvLoginPin = { Name: 'Engine.Login.Pin', TranName: 'mail' };
        self.cmd.Sync(self, SrvLoginPin, function (data) {
          if (self.isEcho()) console.log('doPIN', fUser, data);
        }, 'save', fUser);
      });
      self.on('doLogout', function () {
        self.cmd.Logout(self, function (oData) {
          if(oData.Status){
            setTimeout(function(){ 
							window.location.href = "#";
							window.location.reload();
            }, 800);
          }
        });
      });
      self.on('doClearReset', function () {
        try {
          localStorage.clear();
          setTimeout(function(){ 
            window.location.href = "#";
            window.location.reload();
          }, 800);
        } catch (err) {
          alert(err);
        }
      });      
      self.fire('doRefresh');
    },
    data: function () {
      return {
        loading: false,
        ribbonShow: true,
        UserRow: [],
        CacheData: {
          Users: {}
        },
        Config: {
          UserNotFoundTab: 'notfound'
        },
        InfoKeyClient: "",
        PasswordReset: {
          Step: 1,
          NewPasswordNotValid: false,
          NewPassword: ""
        },
        displayName: "enter",
        User: {},
        login: {
          InfoKey: "",
          ProjectKey: "",
          UserName: "nteerp-test01@mailinator.com",
          UserPass: "test",
          RememberMe: true
        },
				LinkHelp: "",
				LinkManual: "",        
        regex: '^(?!\s*$).+',
        d: Client.createDisplay(),
        Lng: SiteLng.Page.Access,
				styleRegex: function (iValue, iRegex) {
					if (iRegex) {
						if ((re = new RegExp(iRegex)) && (iValue)) {
							if (re.test(iValue)) {
								return '<span class="text-success">*</span>';
							} else {
								return '<span class="text-danger">*</span>';
							}
						}

						return '<span class="text-danger">*</span>';
					}

					return "";
				},
				classEmpty: function(iValue) {
					if (iValue) {
						return '';
					} else {
						return 'empty';
					}
				},
				classRegex: function (iValue, iRegex) {
					if (iRegex) {
						if ((re = new RegExp(iRegex)) && (iValue)) {
							if (re.test(iValue)) {
								return '';
							} else {
								return 'is-invalid';
							}
						}

						return 'is-invalid';
					}

					return "";
				},        
        infoList: function(iValue){
          const myJson = Format.formatXml2Json(iValue);

          return myJson;
        }
      }
    }
  }

component.exports.template = {v:4,t:[{t:4,f:[{t:4,f:[{p:[3,1,48],t:7,e:"div",m:[{n:"class",f:"ribbon ribbon-info ribbon-top-right",t:13}],f:[{p:[3,50,97],t:7,e:"span",f:["NALOG"]}]}],n:50,r:"ribbonShow",p:[2,1,27]},{p:[5,1,132],t:7,e:"br"}," ",{p:[6,1,138],t:7,e:"p",m:[{n:"class",f:"h5 mb-2 text-center",t:13}],f:["PRISTUP"]}," ",{p:[7,1,182],t:7,e:"br"},{p:[7,5,186],t:7,e:"br"}," ",{p:[8,1,192],t:7,e:"p",f:["Lorem ipsum dolor sit amet, consectetur adipisicing elit."]}," ",{t:4,f:[{p:[10,1,287],t:7,e:"br"}," ",{p:[11,1,293],t:7,e:"div",m:[{n:"class",f:"alert alert-warning",t:13},{n:"role",f:"alert",t:13}],f:[{p:[11,47,339],t:7,e:"i",m:[{n:"class",f:"fa fa-exclamation-circle",t:13},{n:"aria-hidden",f:"true",t:13}]},"  ",{t:3,r:"login.MessageError",p:[11,118,410]}]}],n:50,r:"login.MessageError",p:[9,1,258]},{p:[13,1,451],t:7,e:"form",m:[{n:"autocomplete",f:"off",t:13}],f:[{p:[14,2,479],t:7,e:"div",m:[{n:"class",f:"form-floating",t:13}],f:[{p:[15,3,510],t:7,e:"input",m:[{n:"type",f:"email",t:13},{n:"class",f:["form-control ex-action ",{t:2,x:{r:["classEmpty","login.UserName"],s:"_0(_1)"},p:[15,54,561]}," ",{t:2,x:{r:["classRegex","login.UserName","regex"],s:"_0(_1,_2)"},p:[15,85,592]}],t:13},{n:"id",f:"loginUserName",t:13},{n:"name",f:"loginUserName",t:13},{n:"value",f:[{t:2,r:"login.UserName",p:[15,170,677]}],t:13}]}," ",{p:[16,3,700],t:7,e:"label",m:[{n:"for",f:"loginUserName",t:13}],f:["Email",{t:3,x:{r:["styleRegex","login.UserPass","regex"],s:"_0(_1,_2)"},p:[16,35,732]}]}]}," ",{p:[18,3,792],t:7,e:"small",m:[{n:"class",f:"text-danger",t:13}],f:[{t:4,f:[{t:3,r:"Lng.UserName.Mandatory",p:[18,58,847]}],n:50,r:"login.UserNameError",p:[18,30,819]},{t:4,n:51,f:[" "],l:1}]}," ",{p:[19,2,907],t:7,e:"div",m:[{n:"class",f:"form-floating",t:13}],f:[{p:[20,3,938],t:7,e:"input",m:[{n:"type",f:"password",t:13},{n:"class",f:["form-control ex-action ",{t:2,x:{r:["classEmpty","login.UserPass"],s:"_0(_1)"},p:[20,57,992]}," ",{t:2,x:{r:["classRegex","login.UserPass","regex"],s:"_0(_1,_2)"},p:[20,88,1023]}],t:13},{n:"id",f:"loginPassword",t:13},{n:"name",f:"password",t:13},{n:"value",f:[{t:2,r:"login.UserPass",p:[20,168,1103]}],t:13}]}," ",{p:[21,3,1126],t:7,e:"label",m:[{n:"for",f:"loginPassword",t:13}],f:["Password",{t:3,x:{r:["styleRegex","login.UserPass","regex"],s:"_0(_1,_2)"},p:[21,38,1161]}]}]}," ",{p:[23,3,1221],t:7,e:"small",m:[{n:"class",f:"text-danger",t:13}],f:[{t:4,f:[{t:3,r:"Lng.UserPass.Mandatory",p:[23,58,1276]}],n:50,r:"login.PasswordError",p:[23,30,1248]},{t:4,n:51,f:[" "],l:1}]}," ",{p:[24,2,1336],t:7,e:"div",m:[{n:"class",f:"form-group clearfix",t:13}],f:[{p:[25,3,1373],t:7,e:"div",m:[{n:"class",f:"checkbox-custom checkbox-inline checkbox-primary pull-left",t:13}],f:[{p:[26,4,1450],t:7,e:"input",m:[{n:"type",f:"checkbox",t:13},{n:"id",f:"loginRememberMe",t:13},{n:"name",f:"checkbox",t:13}]}," ",{p:[27,4,1515],t:7,e:"label",m:[{n:"for",f:"loginRememberMe",t:13}],f:["Zapamti nalog"]}]}]}," ",{p:[30,3,1588],t:7,e:"div",m:[{n:"class",f:"d-grid mt-3",t:13}],f:[{t:4,f:[{p:[32,5,1641],t:7,e:"button",m:[{n:"type",f:"button",t:13},{n:"class",f:"btn btn-primary ex-action",t:13},{n:"disabled",f:0,t:13}],f:[{p:[32,70,1706],t:7,e:"div",m:[{n:"class",f:"spinner-border spinner-border-sm",t:13},{n:"role",f:"status",t:13}],f:[{p:[32,131,1767],t:7,e:"span",m:[{n:"class",f:"visually-hidden",t:13}],f:["Wait..."]}]}]}],n:50,r:"loading",p:[31,5,1619]},{t:4,n:51,f:[{p:[34,5,1848],t:7,e:"button",m:[{n:"type",f:"button",t:13},{n:"class",f:"btn btn-primary ex-action",t:13},{n:"click",f:{x:{r:["@this","login"],s:"[_0.fire(\"doEnter\",_1)]"}},t:70}],f:["LOGIN"]}],l:1}]}]}," ",{p:[38,1,1992],t:7,e:"p",m:[{n:"class",f:"mt-3",t:13}],f:["Imate problema sa pristupom? ",{p:[39,3,2041],t:7,e:"br"}," ",{p:[40,3,2049],t:7,e:"a",m:[{n:"class",f:"link-primary link-underline-opacity-25 link-underline-opacity-100-hover text-decoration-underline",t:13},{n:"href",f:"#forgot",t:13}],f:["Zaboravio sam lozinku"]}," ",{p:[41,3,2202],t:7,e:"br"}," ",{p:[42,3,2210],t:7,e:"a",m:[{n:"class",f:"link-primary link-underline-opacity-25 link-underline-opacity-100-hover text-decoration-underline",t:13},{n:"href",f:"#help",t:13}],f:["Zaboravio sam email od naloga"]}]}],n:50,x:{r:["d"],s:"_0.isTab(\"enter\")"},p:[1,1,0]},{t:4,f:[{t:4,f:[{p:[47,1,2432],t:7,e:"div",m:[{n:"class",f:"ribbon ribbon-success ribbon-top-right",t:13}],f:[{p:[47,53,2484],t:7,e:"span",f:["dobrodošli"]}]}],n:50,r:"ribbonShow",p:[46,1,2411]},{p:[49,1,2525],t:7,e:"Element-InfoSelect"}],n:50,x:{r:["d"],s:"_0.isTab(\"profil\")"},p:[45,1,2383]},{t:4,f:[{p:[52,1,2607],t:7,e:"h1",f:["NEMA KORISNIKA"]}],n:50,x:{r:["d"],s:"_0.isTab(\"notfound\")"},p:[51,1,2577]}],e:{"_0(_1)":function (_0,_1){return(_0(_1));},"_0(_1,_2)":function (_0,_1,_2){return(_0(_1,_2));},"[_0.fire(\"doEnter\",_1)]":function (_0,_1){return([_0.fire("doEnter",_1)]);},"_0.isTab(\"enter\")":function (_0){return(_0.isTab("enter"));},"_0.isTab(\"profil\")":function (_0){return(_0.isTab("profil"));},"_0.isTab(\"notfound\")":function (_0){return(_0.isTab("notfound"));}}};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Page/Login.html
// module id = 23
// module chunks = 0